import { t } from 'i18next';
import React, { useMemo } from 'react';

import { UIndicator } from 'Components/unit';

import styles from '../SContentCard.style';

export type ContentCardOverlayProps = {
  type: 'already-used' | 'archived';
};

export const ContentCardOverlay = ({ type }: ContentCardOverlayProps) => {
  const UIndicatorProps = useMemo(
    () => ({
      'already-used': {
        mode: 'contrasted',
        text: t('structural_component:s_content_card.already_used'),
      },
      archived: {
        mode: 'light',
        text: t('structural_component:s_content_card.archived'),
      },
    }),
    [],
  );

  const dataTestId = useMemo(() => `${type}-overlay`, [type]);

  return (
    <div style={styles.overlayContainer}>
      <div style={styles.overlay} data-test-id={dataTestId}></div>
      <div style={styles.overlayIndicatorContainer}>
        <UIndicator {...UIndicatorProps[type]} />
      </div>
    </div>
  );
};
